export default "skymp5-front/723795fc9948206018c4e643d5d36a00.png";